import { useRequest } from 'ahooks';
import { Select, SelectProps } from 'antd';
import { customerController } from '../api';
import { useCompany } from '../hooks/company';

export default (props: SelectProps) => {
  const { id: companyId } = useCompany();

  const { data, loading } = useRequest(
    () => {
      return customerController
        .listMobileCity(companyId)
        .then((v) => v.filter((item) => !!item));
    },
    {
      refreshDeps: [companyId],
    },
  );

  return (
    <Select
      {...props}
      placeholder="手机归属城市"
      allowClear
      showSearch
      filterOption={(input, option) =>
        (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
      }
      loading={loading}
      options={data?.map((item) => ({ label: item, value: item }))}
    />
  );
};
